import React from "react";
import momentTz from "moment-timezone";
import {
  getEndAt,
  getScheduledDuration,
  getStartAt,
} from "@sonder/ui/source/styled/components/ScheduleLayer/helpers";
import { PanelCard } from "@sonder/ui/source/styled/fragments/PanelCard";
import { PanelCardProperty } from "@sonder/ui/source/styled/fragments/PanelCardProperty";
import { PanelCardSectionHeader } from "@sonder/ui/source/styled/fragments/PanelCardSectionHeader";
import { ONE_MINUTE } from "core/constants";
import { useCurrentUserTimezone } from "core/hooks/useCurrentTimeZone";
import { TaskData } from "core/queries/GetTask";
import { humanizeTime } from "core/utils/humanizeTime";

export const SchedulingInfoCard = ({ task }: { task: TaskData }) => {
  const userTimezone = useCurrentUserTimezone();
  const { dueAt, completedAt, estimatedDuration, scheduledStartAt, startedAt } =
    task;
  const startAt = getStartAt({
    startedAt,
    dueAt,
    estimatedDuration,
    scheduledStartAt,
  });
  const endAt = getEndAt({
    startedAt,
    estimatedDuration,
    completedAt,
    dueAt,
  });
  const scheduledDuration = getScheduledDuration(startAt, endAt);
  const formattedStartedAt = startedAt
    ? momentTz.tz(startedAt, userTimezone).format("hh:mm A")
    : null;
  const formattedCompletedAt = completedAt
    ? momentTz.tz(completedAt, userTimezone).format("hh:mm A")
    : null;
  return (
    <PanelCard>
      <PanelCardSectionHeader>Scheduling Info</PanelCardSectionHeader>
      <PanelCardProperty
        label="Estimated Duration"
        value={
          estimatedDuration
            ? humanizeTime(estimatedDuration * ONE_MINUTE)
            : "Not Set"
        }
      />
      <PanelCardProperty
        label="Scheduled Duration"
        value={
          scheduledDuration
            ? humanizeTime(scheduledDuration * ONE_MINUTE)
            : "Not Set"
        }
      />
      <PanelCardProperty
        label="Actual Start Time"
        value={formattedStartedAt || "---"}
      />
      <PanelCardProperty
        label="Actual End Time"
        value={formattedCompletedAt || "---"}
      />
    </PanelCard>
  );
};
